<div class="analytics-slider" #analyticsSlider>
  <div class="settings-form">
    @if (settingsFormGroup) {
      <form id="analyticsForm" class="analytics-form" [formGroup]="settingsFormGroup">
        <div class="control-div">
          <label class="collection-control-label"> analytics settings</label>
          @if (CMSText | async; as title) {
            <p class="collection-control-description"> {{title['title']}}
              <a target="_blank" class="read-more" [href]="title['linkUrl']">{{title['linkText']}}</a>.</p>
            }
            <div class="validationField" [style.display]="errorText === true ? 'block' : 'none'">
              <span class="fa fa-exclamation-circle"></span>
              <span [id]="'validationField-collectionName'">
              Menu Name must contain only alphanumeric characters or whitespace.</span>
            </div>
            <div class="label-container">
              <label class="report-label">Node Report Label</label>
            </div>
            <input
              type="text"
              class="collection-control-input"
              [ngClass]="{inputDisabled: isDisabled}"
              formControlName="nodeReportLabel"
              (input)="changeControlEvent()"
              (click)="hideDropdown()"
              [placeholder]="'Enter a label'"
              maxlength="20"
              />
              @if (settingsFormGroup.controls['nodeReportLabel'].invalid) {
                <div class="error-msg"
                  >
                  Node Report Label is required.
                </div>
              }
              <div class="btn-container">
                <button mat-button (click)="showAddToCollection()" class="first-btn"
                  [disabled]="isDisabled"
                  [ngClass]="isDisabled? 'first-btn-disabled' : 'first-btn-active'"><img src='../../../../../assets/svg/add.svg'> Add to Collection
                </button>
                <div class="dropdown">
                  <button class="second-btn"
                    (click)="analyticsDropdown()"
                    [disabled]="isDisabled"
                    [ngClass]="isDisabled? 'second-btn-disabled' : ''"
                    ><img src='../../../../../assets/svg/kebab-icon.svg'>
                  </button>
                  <div class="analyticsDropdownMenu"
                    (mouseleave)="hideDropdown()"
                    (focusout)="hideDropdown()"
                    id="dropdownMenu">
                    <button class="analytics-button" (click)="openPopup()"><img style="float: left" src='../../../../../assets/svg/math-add.png'>Add to new collection</button>
                    <button class="analytics-button" (click)="redirectAnalyticsSettings()" id="analyticsRedirect">
                      <img style="float: left" src='../../../../../assets/svg/settings.png'>Analytics Settings</button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="dropdownMenu" (mouseleave)="hideDropdown()" (focusout)="hideDropdown()">
                @if (isShowAddCollectionList) {
                  <div class="add-to-collection-container">
                    <div class="search-container">
                      <input class="collectionsSearch" placeholder="Search collection" type="text"
                        [ngClass]="{ active: isSearchValue ? true : false }" formControlName="searchValue"  (input)="searchCollection()" />
                        @if (isSearchValue) {
                          <div class="cancel-btn" (click)="clearSearch()"></div>
                        }
                      </div>
                      <div class="collection-list-container">
                        @if (assets.length > 0) {
                          <ul>
                            @for (collectionItem of collectionItems; track collectionItem) {
                              <li class="menu_item" (click)="collectionItem.inUse ? null : addCllection(collectionItem)">
                                @if (collectionItem.featureName.length > 20) {
                                  @if (collectionItem.inUse) {
                                    <span class="menu_item_label collection-disabled" [matTooltip]="'Already used'" matTooltipPosition="above" [class]="collectionItem.featureType">{{collectionItem.featureName.substr(0,17)}}...</span>
                                  }
                                  @if (!collectionItem.inUse) {
                                    <span matTooltip="{{collectionItem.featureName}}" matTooltipPosition="above" class="menu_item_label" [class]="collectionItem.featureType">
                                    {{collectionItem.featureName.substr(0,17)}}...</span>
                                  }
                                } @else {
                                  @if (collectionItem.inUse) {
                                    <span class="menu_item_label collection-disabled" [matTooltip]="'Already used'" matTooltipPosition="above" [class]="collectionItem.featureType">{{collectionItem.featureName}}</span>
                                  }
                                  @if (!collectionItem.inUse) {
                                    <span matTooltip="{{collectionItem.featureName}}" matTooltipPosition="above" class="menu_item_label" [class]="collectionItem.featureType">
                                    {{collectionItem.featureName}}</span>
                                  }
                                }
                              </li>
                            }
                          </ul>
                        }
                        @if (isShowNoSearchResult) {
                          <div class="no-result-block">No results found.</div>
                        }
                        @if (assets.length === 0 && !isShowNoSearchResult) {
                          <div class="empty-block">
                            <div>No collection available.<br/><br/>
                              Create a collection from <br/>the overflow menu.<br/>
                              <img class="kebab-icon" src="../../../../../../../../assets/svg/kebab-icon.svg">
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (!isShowAddCollectionList) {
                    <div class="cards-container">
                      @for (card of cardCollections.controls; track card; let i = $index) {
                        <ng-container formArrayName="cardCollections">
                          @if (collectionCardsList[i]?.type === 'SINGLE_STEP') {
                            <div  [formGroupName]="i" class="card single-data-card">
                              @if (!isDisabled) {
                                <div class="delete-card" matTooltipClass="mat-tooltip-delete" [matTooltip]="'Remove collection'" matTooltipPosition="above" (click)="removeCollection(collectionCardsList[i], i)"></div>
                              }
                              <div class="card-content">
                                @if (collectionCardsList[i].name.length>20) {
                                  <div class="collection-name" matTooltip="{{collectionCardsList[i].name}}" matTooltipPosition="above">
                                    {{ collectionCardsList[i].name.substr(0,17)}}...
                                  </div>
                                } @else {
                                  <div class="collection-name">{{ collectionCardsList[i].name}}...</div>
                                }
                                <div class="collection-type">{{ singleData }}</div>
                                <input type="hidden" formControlName="level" value="0" />
                              </div>
                            </div>
                          }
                          @if (collectionCardsList[i]?.type === 'SIMPLE') {
                            <div [formGroupName]="i" class="card start-end-data-card">
                              @if (!isDisabled) {
                                <div class="delete-card" matTooltipClass="mat-tooltip-delete" [matTooltip]="'Remove collection'" matTooltipPosition="above" (click)="removeCollection(collectionCardsList[i], i)"></div>
                              }
                              <div class="card-header">
                                @if (collectionCardsList[i].name.length>20) {
                                  <div class="collection-name" matTooltip="{{collectionCardsList[i].name}}" matTooltipPosition="above">
                                    {{ collectionCardsList[i].name.substr(0,17)}}...
                                  </div>
                                } @else {
                                  <div class="collection-name">{{ collectionCardsList[i].name}}...</div>
                                }
                                <div class="collection-type">{{ startAndEndData }}</div>
                              </div>
                              <div class="card-content">
                                <label class="card-radio">
                                  <input  type="radio" formControlName="level" value="0" [attr.disabled]="isDisabled? '' : null"><span class="radio-label">Report Start</span>
                                </label>
                                <label class="card-radio">
                                  <input  type="radio" formControlName="level" value="99" [attr.disabled]="isDisabled? '' : null"><span class="radio-label">Report End</span>
                                </label>
                              </div>
                            </div>
                          }
                          @if (collectionCardsList[i]?.type === 'FULL') {
                            <div class="card multi-data-card" [formGroupName]="i">
                              @if (!isDisabled) {
                                <div class="delete-card" matTooltipClass="mat-tooltip-delete" [matTooltip]="'Remove collection'" matTooltipPosition="above" (click)="removeCollection(collectionCardsList[i], i)"></div>
                              }
                              <div class="card-header">
                                @if (collectionCardsList[i].name.length>20) {
                                  <div class="collection-name" matTooltip="{{collectionCardsList[i].name}}" matTooltipPosition="above">
                                    {{ collectionCardsList[i].name.substr(0,17)}}...
                                  </div>
                                } @else {
                                  <div class="collection-name">{{ collectionCardsList[i].name}}...</div>
                                }
                                <div class="collection-type">{{ multiData }}</div>
                              </div>
                              <div class="card-content">
                                <mat-select
                                  disableOptionCentering
                                  class="report-level-select {{card.controls['level'].invalid && card.controls['level'].touched?'report-level-error':''}}"
                                  panelClass="report-level-select-panel"
                                  placeholder="Select report level"
                                  formControlName="level"
                                  [disabled]="isDisabled"
                                  >
                                  @for (level of reportLevels; track level) {
                                    <mat-option [value]="level.value">{{ level.name }}</mat-option>
                                  }
                                </mat-select>
                                @if (card.controls['level'].invalid && card.controls['level'].touched) {
                                  <div class="report-level-error-msg">Report level not selected</div>
                                }
                              </div>
                            </div>
                          }
                        </ng-container>
                      }
                    </div>
                  }
                </div>
              </form>
            }
          </div>
          <div class="nodeFooterHolder">
            <div class="nodeHeader-button">
              <div class="btn close-btn" [ngClass]="{'right-margin': isDisabled}" id="closeTrackNode" (click)="closeAnalyticsOverlay()">Close</div>
              @if (!isDisabled) {
                <div class="btn save-btn" id="saveTrackNode" (click)="saveSettings()">Save</div>
              }
            </div>
          </div>
        </div>
